var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 7 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M13 17c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4m9.707 4.293-4.82-4.82A5.97 5.97 0 0 0 19 13a6 6 0 0 0-12 0 6 6 0 0 0 6 6 5.97 5.97 0 0 0 3.473-1.113l4.82 4.82a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414"
})));
export default SvgSearch;